import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import './admin.css';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import apiUrl from '../assets/apiUrl';

// 누적 데이터 생성 함수
function getCumulativeData(data) {
  let sum = 0;
  return data.map(item => {
    sum += item.count;
    return { ...item, count: sum };
  });
}

function Admin() {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('dashboard');
  const [dashboardData, setDashboardData] = useState(null);

  useEffect(() => {
    const fetchDashboardData = async () => {
      const response = await fetch(`${apiUrl}/api/deepquant/etc/admin/dashboard`);
      const data = await response.json();
      setDashboardData(data.result);
    };

    fetchDashboardData();
  }, []);

  // 누적 가입자 데이터 생성
  const cumulativeUserChartData =
    dashboardData && dashboardData[0].user_chart_data
      ? getCumulativeData(dashboardData[0].user_chart_data)
      : [];

  const handleLogout = () => {
    logout();
    navigate('/admin');
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return (
          <div className="tab-content">
            <div className="admin-section">
              <h2>통계 대시보드</h2>
              <div className="admin-stats">
                <div className="stat-card">
                  <h3>(1) 총 가입자</h3>
                  <p>{dashboardData && dashboardData[0].user_count}</p>
                </div>
                <div className="stat-card" style={{ background: "#232946" }}>
                  <h3>(1-1) 구글 가입자</h3>
                  <p>{dashboardData && dashboardData[0].user_google_count}</p>
                </div>
                <div className="stat-card" style={{ background: "#232946" }}>
                  <h3>(1-1) 애플 가입자</h3>
                  <p>{dashboardData && dashboardData[0].user_apple_count}</p>
                </div>
                <div className="stat-card" style={{ background: "rgba(183, 170, 255, 0.1)" }}>
                  <h3>(1-2) 한국 가입자</h3>
                  <p>{dashboardData && dashboardData[0].user_korea_count}</p>
                </div>
                <div className="stat-card" style={{ background: "rgba(183, 170, 255, 0.1)" }}>
                  <h3>(1-2) 외국 가입자</h3>
                  <p>{dashboardData && dashboardData[0].user_foreign_count}</p>
                </div>
              </div>
              <div className="admin-stats">
                <div className="stat-card">
                  <h3>(2) 총 구독자</h3>
                  <p>{dashboardData && dashboardData[0].subscribe_count}</p>
                </div>
                <div className="stat-card" style={{ background: "#232946" }}>
                  <h3>(2-1) 구글 구독자</h3>
                  <p>{dashboardData && dashboardData[0].subscribe_android_count}</p>
                </div>
                <div className="stat-card" style={{ background: "#232946" }}>
                  <h3>(2-1) 애플 구독자</h3>
                  <p>{dashboardData && dashboardData[0].subscribe_ios_count}</p>
                </div>
                <div className="stat-card">
                  <h3>(3) 알람 사용자</h3>
                  <p>{dashboardData && dashboardData[0].user_alarm_count}</p>
                </div>
              </div>
            </div>
            <div className="admin-section">
              <h2>날짜별 가입자 추이</h2>
              <div style={{ width: '100%', overflowX: 'auto', paddingBottom: 12 }}>
                <div style={{ minWidth: 900, height: 320 }}>
                  <ResponsiveContainer width="100%" height="100%">
                    <LineChart data={cumulativeUserChartData || []} margin={{ top: 20, right: 40, left: 0, bottom: 20 }}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
                      <XAxis dataKey="date" tick={{ fill: '#b7aaff', fontSize: 13 }} angle={-30} textAnchor="end" height={60} />
                      <YAxis tick={{ fill: '#b7aaff', fontSize: 13 }} />
                      <Tooltip contentStyle={{ background: '#23253a', color: '#fff', borderRadius: 8, border: 'none' }} labelStyle={{ color: '#b7aaff' }} />
                      <Line type="monotone" dataKey="count" stroke="#7c5dfa" strokeWidth={3} dot={{ r: 4, fill: '#fff', stroke: '#7c5dfa', strokeWidth: 2 }} activeDot={{ r: 6 }} />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </div>

              <h2 style={{ color: '#4FC3F7' }}>날짜별 DAU 추이</h2>
              <div style={{ width: '100%', overflowX: 'auto', paddingBottom: 12 }}>
                <div style={{ minWidth: 900, height: 320 }}>
                  <ResponsiveContainer width="100%" height="100%">
                    <LineChart data={(dashboardData && dashboardData[0].user_login_chart_data) || []} margin={{ top: 20, right: 40, left: 0, bottom: 20 }}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
                      <XAxis dataKey="date" tick={{ fill: '#4FC3F7', fontSize: 13 }} angle={-30} textAnchor="end" height={60} />
                      <YAxis tick={{ fill: '#4FC3F7', fontSize: 13 }} />
                      <Tooltip contentStyle={{ background: '#23253a', color: '#fff', borderRadius: 8, border: 'none' }} labelStyle={{ color: '#4FC3F7' }} />
                      <Line type="monotone" dataKey="count" stroke="#2ACBE0" strokeWidth={3} dot={{ r: 4, fill: '#fff', stroke: '#2ACBE0', strokeWidth: 2 }} activeDot={{ r: 6 }} />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </div>
          </div>
        );

      case 'user_login':
        return (
          <div className="tab-content">
            <div className="admin-section">
              <h2>로그인 기록 데이터</h2>
              <div style={{ width: '100%', overflowX: 'auto' }}>
                <table style={{ 
                  width: '100%',
                  borderCollapse: 'collapse',
                  background: '#232946',
                  borderRadius: '12px',
                  overflow: 'hidden'
                }}>
                  <thead>
                    <tr style={{
                      background: 'rgba(183, 170, 255, 0.1)',
                      borderBottom: '1px solid rgba(255,255,255,0.1)'
                    }}>
                      <th style={{ padding: '16px', color: '#b7aaff' }}>유저 ID</th>
                      <th style={{ padding: '16px', color: '#b7aaff' }}>닉네임</th>
                      <th style={{ padding: '16px', color: '#b7aaff' }}>이메일</th>
                      <th style={{ padding: '16px', color: '#b7aaff' }}>구독 os</th>
                      <th style={{ padding: '16px', color: '#b7aaff' }}>로그인 시간</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dashboardData && dashboardData[0].user_login_data.map((item, index) => (
                      <tr key={index} style={{
                        borderBottom: '1px solid rgba(255,255,255,0.05)'
                      }}>
                        <td style={{ padding: '14px 16px', color: '#fff' }}>{item.user_id}</td>
                        <td style={{ padding: '14px 16px', color: '#fff' }}>{item.username}</td>
                        <td style={{ padding: '14px 16px', color: '#fff' }}>{item.email}</td>
                        <td style={{ padding: '14px 16px', color: '#fff' }}>{item.os}</td>
                        <td style={{ padding: '14px 16px', color: '#fff' }}>{new Date(new Date(item.created_at).getTime() + 9 * 60 * 60 * 1000).toLocaleString()}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        );

      case 'user_alarm':
        return (
          <div className="tab-content">
            <div className="admin-section">
              <h2>전략 알람 통계</h2>
              <div style={{ width: '100%', overflowX: 'auto' }}>
                <table style={{ 
                  width: '100%',
                  borderCollapse: 'collapse',
                  background: '#232946',
                  borderRadius: '12px',
                  overflow: 'hidden'
                }}>
                  <thead>
                    <tr style={{
                      background: 'rgba(183, 170, 255, 0.1)',
                      borderBottom: '1px solid rgba(255,255,255,0.1)'
                    }}>
                      <th style={{ padding: '16px', color: '#b7aaff' }}>코인 심볼</th>
                      <th style={{ padding: '16px', color: '#b7aaff' }}>전략명</th>
                      <th style={{ padding: '16px', color: '#b7aaff' }}>사용자 수</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dashboardData && dashboardData[0].user_alarm_statistics.map((item, index) => (
                      <tr key={index} style={{
                        borderBottom: '1px solid rgba(255,255,255,0.05)'
                      }}>
                        <td style={{ padding: '14px 16px', color: '#fff' }}>{item.symbol}</td>
                        <td style={{ padding: '14px 16px', color: '#fff' }}>{item.name}</td>
                        <td style={{ padding: '14px 16px', color: '#fff' }}>{item.count}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="admin-section">
              <h2>전략 알람 데이터</h2>
              <div style={{ width: '100%', overflowX: 'auto' }}>
                <table style={{ 
                  width: '100%',
                  borderCollapse: 'collapse',
                  background: '#232946',
                  borderRadius: '12px',
                  overflow: 'hidden'
                }}>
                  <thead>
                    <tr style={{
                      background: 'rgba(183, 170, 255, 0.1)',
                      borderBottom: '1px solid rgba(255,255,255,0.1)'
                    }}>
                      <th style={{ padding: '16px', color: '#b7aaff' }}>유저 ID</th>
                      <th style={{ padding: '16px', color: '#b7aaff' }}>닉네임</th>
                      <th style={{ padding: '16px', color: '#b7aaff' }}>이메일</th>
                      <th style={{ padding: '16px', color: '#b7aaff' }}>코인 심볼</th>
                      <th style={{ padding: '16px', color: '#b7aaff' }}>전략명</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dashboardData && dashboardData[0].user_alarm_data.map((item, index) => (
                      <tr key={index} style={{
                        borderBottom: '1px solid rgba(255,255,255,0.05)'
                      }}>
                        <td style={{ padding: '14px 16px', color: '#fff' }}>{item.user_id}</td>
                        <td style={{ padding: '14px 16px', color: '#fff' }}>{item.username}</td>
                        <td style={{ padding: '14px 16px', color: '#fff' }}>{item.email}</td>
                        <td style={{ padding: '14px 16px', color: '#fff' }}>{item.symbol}</td>
                        <td style={{ padding: '14px 16px', color: '#fff' }}>{item.name}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        );

      default:
        return <div>탭을 선택해주세요.</div>;
    }
  };

  return (
    <div className="admin-container">
      <div className="admin-header">
        <h1>관리자 대시보드</h1>
        <button onClick={handleLogout} className="logout-button">
          로그아웃
        </button>
      </div>
      
      <div className="admin-layout">
        <div className="admin-sidebar">
          <nav className="admin-nav">
            <button 
              className={`nav-tab ${activeTab === 'dashboard' ? 'active' : ''}`}
              onClick={() => setActiveTab('dashboard')}
            >
              <span className="tab-icon">📊</span>
              대시보드
            </button>
            <button 
              className={`nav-tab ${activeTab === 'user_login' ? 'active' : ''}`}
              onClick={() => setActiveTab('user_login')}
            >
              <span className="tab-icon">👤</span>
              로그인 기록
            </button>
            <button 
              className={`nav-tab ${activeTab === 'user_alarm' ? 'active' : ''}`}
              onClick={() => setActiveTab('user_alarm')}
            >
              <span className="tab-icon">🔔</span>
              전략 알람
            </button>
          </nav>
        </div>
        
        <div className="admin-main">
          {renderTabContent()}
        </div>
      </div>
    </div>
  );
}

export default Admin;
